import { render, staticRenderFns } from "./father.vue?vue&type=template&id=546a5280&scoped=true"
import script from "./father.vue?vue&type=script&lang=js"
export * from "./father.vue?vue&type=script&lang=js"
import style0 from "./father.vue?vue&type=style&index=0&id=546a5280&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a5280",
  null
  
)

export default component.exports